module.exports = __webpack_public_path__ + "img/youtube-circle.83fbf6c4.svg";